import { FC } from "react";
import "./App.css";
import RouterRoot from "./common/router/RouterRoot";

export const App: FC = () => {
  return <RouterRoot />;
};

export default App;
